const isSdkMode = (): boolean => {
  const app = document.getElementById('conferwith');
  // @ts-ignore
  return window.sdkModeEnabled && app;
};
export default isSdkMode;
